/**
 * 📚 Course Domain API Custom Axios Instance
 * shared/auth-core 통합 버전 - Course Server 연동
 */

import { createOrvalCustomInstance } from '@edusense/shared-auth-core';

const getCourseApiBaseUrl = (): string => {
  return process.env.COURSE_API_BASE_URL || 'https://api.ugot.uk';
};

export const customInstance = createOrvalCustomInstance(
  getCourseApiBaseUrl(),
  {
    timeout: 30000,
    enableDebug: process.env.NODE_ENV === 'development',
    onAuthError: () => {
      console.warn('API 인증 만료 - 토큰만 정리하고 현재 페이지 유지');
    },
  }
);

export default customInstance;

export type ErrorType<T> = import('@edusense/shared-auth-core').AuthAxiosError<T>;
